import { Component, OnInit, inject, signal } from '@angular/core';
import { PlayerInfoAnalyticsService } from '@app/core/analytics/firehose/public-api';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { LoggerService } from '@app/shared/services/logger.service';
import { PreLoaderService } from '@app/shared/services/pre-loader.service';
import { WalletService } from '@app/shared/services/wallet.service';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserRepository } from '@app/shared/state/user/user.repository';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '@app/layout/slotcom-header/slotcom-header.component';
import { PreLoaderComponent } from '@app/shared/components/pre-loader/pre-loader.component';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
  imports: [RouterModule, HeaderComponent, PreLoaderComponent],
})
export class HomeComponent implements OnInit {
  get user() {
    return this.userRepo.getUser();
  }

  appLoaded = signal(false);

  componentDestroy: () => Observable<unknown>;

  private readonly preloaderService = inject(PreLoaderService);
  private readonly userRepo = inject(UserRepository);
  public readonly logger = inject(LoggerService);
  private readonly playerInfoAnalytics = inject(PlayerInfoAnalyticsService);
  private readonly walletService = inject(WalletService);

  constructor() {
    toObservable(this.preloaderService.completed)
      .pipe(filter(Boolean), takeUntilDestroyed())
      .subscribe(() => this.finishInit());
  }

  ngOnInit() {
    this.preloaderService.init();
  }

  private async finishInit(): Promise<void> {
    try {
      await this.walletService.refreshUserWallet();
      this.playerInfoAnalytics.trackPlayerInfoAvailable();
    } catch (err) {
      this.logger.error('HomeComponent: Failed to refresh wallet', err);
    } finally {
      this.appLoaded.set(true);
    }
  }
}
